// @flow
import {buildRoute} from '../../http';
import {endpoints} from '../../modules/file-storage/api';
// import {Cloudinary} from './cloudinary';

import noimage from '../../assets/img/noimage.png';

/*export type GetImageUrlOptions = {
  width?: number,
  height?: number,
  customProps?: string,
};

export const providers = Object.freeze({
  CLOUDINARY: 'CLOUDINARY',
});

export type ProviderId = $Keys<typeof providers>;

export interface ImageProvider {
  getImageUrl(imageId: string, options?: GetImageUrlOptions): string;
}

const providersMap: {[key: ProviderId]: ImageProvider} = {
  [providers.CLOUDINARY]: new Cloudinary(),
};

export const getProviderImageUrl = (
  imageId?: string,
  options?: GetImageUrlOptions,
  providerId: ProviderId = providers.CLOUDINARY
): string => {
  if (!imageId || typeof imageId !== 'string') return noimage;
  const prov = providersMap[providerId];
  if (!prov) throw new Error(`Provider "${providerId}" does not exist`);
  return prov.getImageUrl(imageId, options);
};*/

export const getImageUrl = (fileId: ?string, defaultImage: string = noimage) =>
  fileId ? buildRoute(endpoints.GET_FILE_STORE, [fileId]) : defaultImage;

export const getFileUrl = (fileId: ?string) =>
  fileId ? buildRoute(endpoints.GET_FILE_STORE, [fileId]) : '';

export const getFileInformationUrl = (fileId: ?string) =>
  fileId ? buildRoute(endpoints.GET_FILE_INFORMATION, [fileId]) : '';
